<app-modal #modal>
  <div class="modal-header">
    <h2 class="modal-title" style="text-align: left">{{ action === 'unset' ? 'Stop WIP?' : 'Set as WIP?' }}</h2>
  </div>
  <div class="modal-body" style="text-align: left; padding-top: 15px;">
    <form [formGroup]="form">
      <div class="checkbox-wrap last">
        <div class="form-group">
          <label class="checkbox">
            <input type="checkbox" id="allExpenses" formControlName="allExpenses" value="true">
            <span></span>
          </label>
          <label class="checkbox-label" for="allExpenses">Apply to all pending expenses for this patient?</label>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <app-button text="Cancel" variant="secondary" width="fill" (clicked)="onNotConfirmed()" />
      </div>

      <div class="col-6">
        <app-button text="Confirm" width="fill" (clicked)="onConfirmed()" />
      </div>
    </div>
  </div>
</app-modal>
